document.addEventListener("turbo:load", () => {
  const flashes = document.querySelectorAll(".flash-notice");

  flashes.forEach((flash) => {
    setTimeout(() => {
      flash.style.transition = "opacity 0.5s ease";
      flash.style.opacity = "0";

      setTimeout(() => flash.remove(), 500);
    }, 4000);
  });
});
